export default __webpack_public_path__ + "static/media/rating_web-lg@2x.64342de2.jpg";